import type { IActionItem } from '@model/actionItem';

export const getTranslatesNetworkAiTextBlocks = (item: IActionItem, targetLanguage: string) => {
  const translatedObj: { [key: string]: string } = {};

  const translationFields = Object.keys(item?.networkAiTextBlocks || {});
  const descriptionTranslate = item?.translates?.[targetLanguage]?.['description'];

  if (descriptionTranslate) {
    translatedObj['description'] = descriptionTranslate;
  }

  translationFields.forEach((field) => {
    const transField = item?.translates?.[targetLanguage]?.[field];

    if (transField) {
      translatedObj[field] = transField?.text || '';
    }
  });

  return translatedObj;
};
